import Header from '../components/Header';
import EditForm from '../components/EditForm/EditForm';
import HelpButton from '../components/Help/HelpButton';
import GuideModal from '../components/Help/GuideModal';
import { IMAGES } from '../constants/images';
import { useState } from 'react';
import MainEditor from '../components/EditForm/MainEditor';

const ArticleEditPage = () => {
  const [isGuideOpen, setIsGuideOpen] = useState(true);
  const [postTitle, setPostTitle] = useState('');
  const [isAltTextLoading, setIsAltTextLoading] = useState(false);
  const [isAltTextSuccess, setIsAltTextSuccess] = useState(false);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <div className="flex flex-col p-8">
        <div className="flex">
          <EditForm postTitle={postTitle} setPostTitle={setPostTitle} />
          <HelpButton onClick={() => setIsGuideOpen(true)} />
          {isGuideOpen && <GuideModal onClose={() => setIsGuideOpen(false)} />}
        </div>
        <MainEditor
          postTitle={postTitle}
          setIsAltTextLoading={setIsAltTextLoading}
          setIsAltTextSuccess={setIsAltTextSuccess}
        />
      </div>

      {/* 🔄 로딩 모달 */}
      {isAltTextLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="flex flex-col items-center p-6 bg-white rounded-md shadow-md w-[480px]">
            <img
              src={IMAGES.loader}
              alt="로딩 중"
              className="w-12 h-12 mb-5 animate-spin"
            />
            <p className="text-lg font-medium text-gray-700">
              대체 텍스트를 생성 중입니다.
            </p>
            <span className="mt-5 text-sm">잠시만 기다려주세요.</span>
          </div>
        </div>
      )}

      {/* ✅ 성공 모달 */}
      {isAltTextSuccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="flex flex-col items-center p-6 bg-white rounded-md shadow-md w-[480px]">
            <img src={IMAGES.check} alt="완료" className="w-12 h-12 mb-5" />
            <p className="text-lg font-medium text-gray-700">
              대체 텍스트 생성이 완료되었습니다.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArticleEditPage;
